import React from 'react';

import Button from '~/components/core/Atomic/Buttons/Button';
import { CheckIcon } from '~/components/icons';
import cn from '~/Utils/cn';

interface ExecuteButtonProps {
  onExecute: () => void;
  isDone: boolean;
}

export const InvoiceExecuteButton: React.FC<ExecuteButtonProps> = ({ onExecute, isDone }) => {
  return (
    <Button
      variant="contained"
      classes={{
        root: `ml-auto leading-none bg-green-700 text-white ${isDone ? '[&&]:bg-green-700/10 [&&]:text-green-700' : ''}`,
      }}
      onClick={onExecute}
    >
      <CheckIcon
        height={16}
        width={16}
        className={cn('mr-12 rounded-full border-1 border-solid border-white fill-white px-2 pb-2', {
          ['border-green-700 fill-green-700']: isDone,
        })}
      />
      {isDone ? 'View Analysis' : 'Open Analysis'}
    </Button>
  );
};
